import { render, staticRenderFns } from "./MelosButtonSet.vue?vue&type=template&id=203a00fe&scoped=true&"
import script from "./MelosButtonSet.vue?vue&type=script&lang=ts&"
export * from "./MelosButtonSet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203a00fe",
  null
  
)

export default component.exports